import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import { useIsBreakpointSize } from 'app/shared/utils';
import { Icon } from 'app/shared/components/atoms';
import { Box, Typography } from 'app/shared/components/atoms';
import { ReactComponent as AlertCircle } from 'icons/alert-circle.svg';

interface Props {
  children: React.ReactNode;
  displayIcon?: boolean;
  invertColors?: boolean;
  colorOverride?: string;
  'data-qaid'?: string;
}

const ErrorIcon = ({ color }: { color: string }) => {
  return (
    <Icon
      size="xs"
      display="inline-flex"
      icon={AlertCircle}
      strokeColor={color}
    />
  );
};

export const FormErrorMessage = ({
  children,
  displayIcon = true,
  invertColors = false,
  colorOverride,
  'data-qaid': qaId = 'form-error-message',
}: Props) => {
  const { colors, fontSizes } = useCurrentTheme();
  const { isDesktop } = useIsBreakpointSize();

  const color =
    colorOverride || colors.messaging.error[invertColors ? 'light' : 'dark'];
  const lineHeight = fontSizes.fontSize100[isDesktop ? 'desktop' : 'mobile'];

  return (
    <Box alignItems="flex-start" gap={1} data-qaid={qaId}>
      {displayIcon && (
        <Box h={lineHeight} alignItems="center">
          <ErrorIcon color={color} />
        </Box>
      )}

      <Typography lineHeight="100%" color={color}>
        {children}
      </Typography>
    </Box>
  );
};
